//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
/** Components Import */
import {
  Stack,
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
  Divider,
  IconButton,
  Card,
  CardContent,
  CardActions,
  TextField,
  ListItemIcon,
  CardHeader,
  Badge,
  styled,
  createTheme,
  ThemeProvider,
  CssBaseline,
  Button as MuiButton,
} from '@mui/material';
import { Button, Combo, Dialog, Radio, Checkbox } from '../../Components/MUIs';
import { KakaoPost } from '../../Components/Kakaos';
/** Icons Import */
import {
  Settings as SettingsIcon,
  Lock as LockIcon,
  Notifications as AlarmSettingIcon,
  Logout as LogoutIcon,
  ArrowForwardIos as RightArrowIcon,
  NavigateBefore as BackIcon,
  Check as CheckIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import avata from '../../Assets/Images/avata_160x160.png';
import vector from '../../Assets/Images/Vector.png';
import { FileForm } from '../../Components/FileForm';
import Commons from '../../Services/Common/Common';
import Canvas from '../../Components/Canvas/Canvas';
import safeonJourneyman1 from '../../Assets/Images/safeOn_journeyman1.png';
import safeonJourneyman2 from '../../Assets/Images/safeOn_journeyman2.png';
//#endregion

const theme = createTheme({
  typography: {
    htmlFontSize: 7,
    fontFamily: 'Pretendard, sans-serif',
  },
  palette: {
    // mode: "dark",
    // background: {
    // 	default: "#090e23",
    // 	paper: "#090e23",
    // },
    primary: {
      light: '#008b43',
      main: '#008b43',
      dark: '#00b557',
      contrastText: '#fff',
    },
    // secondary: {
    // 	light: "#ff7961",
    // 	main: "#f44336",
    // 	dark: "#ba000d",
    // 	contrastText: "#000",
    // },
  },
  button: {
    backgroundColor: '#F3F7F8',
    color: '#000',
    fontSize: '28px',
    width: '180px',
    height: '60px',
    borderRadius: '16px',
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function MyPage_Mobile(props) {
  //#region 변수
  const [kakaoPost, setKakaoPost] = useState(false); // 카카오 지도
  const signatureCanvas = useRef(); // 서명 REF
  //#endregion
  //#region 데이터
  //#endregion
  //#region 나머지 함수
  const GetPostData = (_data) => {
    props.setInputs2({
      ...props.inputs2,
      post: _data.road_address.zone_no,
      address1: _data.road_address.address_name,
    });
  };

  const myPageDefault = () => (
    <Stack spacing={1}>
      <Box sx={{ p: 1 }}>
        <Card>
          <CardHeader
            sx={{ mt: 2 }}
            titleTypographyProps={{
              textAlign: 'center',
              fontSize: '24px',
              fontWeight: 700,
            }}
            title={
              props.lanInfo.length > 0
                ? props.lanInfo.filter((f) => f.LAN_ID === 'MyPage')[0].LAN_NM // 내 정보
                : ''
            }
          />
          <CardContent>
            <List>
              <React.Fragment>
                <ListItem sx={{ py: 1 }}>
                  <ListItemButton
                    sx={{
                      p: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                    onClick={() => props.setMobileModalToggle(true)}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                        <SettingsIcon sx={{ fontSize: '24px' }} />
                      </ListItemAvatar>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: '16px',
                        }}
                        primary={
                          props.lanInfo.length > 0
                            ? props.lanInfo.filter(
                                (f) => f.LAN_ID === 'EditPersonalInfo'
                              )[0].LAN_NM // 개인정보 수정
                            : ''
                        }
                      />
                    </Box>
                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                      <RightArrowIcon
                        sx={{
                          ml: 2,
                          fontSize: '16px',
                          color: '#000000',
                        }}
                      />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
                <Divider variant="middle" />
              </React.Fragment>
              <React.Fragment>
                <ListItem sx={{ py: 1 }}>
                  <ListItemButton
                    sx={{
                      p: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                    onClick={() => props.setMobileModalToggle2(true)}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
                        <LockIcon sx={{ fontSize: '24px' }} />
                      </ListItemAvatar>
                      <ListItemText
                        primaryTypographyProps={{
                          fontSize: '16px',
                        }}
                        primary={
                          props.lanInfo.length > 0
                            ? props.lanInfo.filter(
                                (f) => f.LAN_ID === 'ChangePassword'
                              )[0].LAN_NM // 비밀번호 변경
                            : ''
                        }
                      />
                    </Box>
                    <ListItemIcon sx={{ minWidth: 'auto' }}>
                      <RightArrowIcon
                        sx={{
                          ml: 2,
                          fontSize: '16px',
                          color: '#000000',
                        }}
                      />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              </React.Fragment>
            </List>
          </CardContent>
        </Card>
      </Box>
    </Stack>
  );

  const profile = () => (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginTop: '10px',
        }}
      >
        <IconButton
          onClick={() => {
            props.setViewState(0);
          }}
        >
          <BackIcon fontSize="large" sx={{ fontSize: '35px' }} />
        </IconButton>
        <div style={{ width: '10%' }} />
      </div>
      <Stack>
        <List>
          <ListItem
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ListItemAvatar>
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                badgeContent={
                  <>
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/*"
                      id="upload-button"
                      onChange={(event) => {
                        const fileList = event.target.files;
                        if (Object.keys(fileList).length === 0) return;

                        const file = fileList[0]; // single file upload

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (e) => {
                          fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => {
                              const image = new File(
                                [blob],
                                `${new Date()
                                  .toISOString()
                                  .replace(/T/, '')
                                  .replace(/\..+/, '')
                                  .replace(/-/g, '')
                                  .replace(/:/g, '')}.png`,
                                {
                                  type: '/png',
                                }
                              );

                              props.setImageFile({
                                ...props.imageFile,
                                profileFiles: reader.result,
                                profileImage: image,
                                profileFileName: file.name,
                              });
                            });
                        };
                        reader.onerror = (error) => {
                          console.log(error);
                          // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                        };
                      }}
                    />
                    <IconButton
                      onClick={() =>
                        document.getElementById('upload-button').click()
                      }
                    >
                      <SettingsIcon sx={{ fontSize: '24px' }} />
                    </IconButton>
                  </>
                }
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  badgeContent={
                    <IconButton
                      onClick={() => {
                        props.DeleteLogic2();
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  }
                >
                  {props.imageFile.profileFiles ? (
                    <Avatar
                      sx={{ width: 80, height: 80 }}
                      src={props.imageFile.profileFiles}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: '80px',
                        height: '80px',
                        padding: '10px',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img src={avata} width="100%" height="100%"></img>
                    </Box>
                  )}
                </Badge>
              </Badge>
            </ListItemAvatar>
          </ListItem>
        </List>
        <List>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Id')[0].LAN_NM // 아이디
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={props.inputs2.id ? props.inputs2.id : ''}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'BirthDate')[0]
                      .LAN_NM // 생년월일
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={
                  props.inputs2.birth
                    ? props.inputs2.birth.slice(0, 4) +
                      '-' +
                      props.inputs2.birth.slice(4, 6) +
                      '-' +
                      props.inputs2.birth.slice(6)
                    : ''
                }
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Nationality')[0]
                      .LAN_NM // 국적
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.nationList}
                value={props.inputs2.nation}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    nation: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                  fontSize: '16px',
                }}
                size="small"
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'BloodType')[0]
                      .LAN_NM // 혈액형
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.bloodList}
                value={props.inputs2.blood}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    blood: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                  fontSize: '16px',
                }}
                size="small"
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Name')[0].LAN_NM // 이름
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.name ? props.inputs2.name : ''}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    name: e.target.value,
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'EMail')[0].LAN_NM // 이메일
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.email ? props.inputs2.email : ''}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    email: e.target.value,
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Tel')[0].LAN_NM // 전화번호
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.tel ? props.inputs2.tel : ''}
                type="tel"
                inputProps={{ maxLength: 13 }}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    tel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'EmTel')[0].LAN_NM // 비상연락처
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.emtel ? props.inputs2.emtel : ''}
                type="tel"
                inputProps={{ maxLength: 13 }}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    emtel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Post')[0].LAN_NM // 우편번호
                  : ''}
              </Typography>
              <Stack
                sx={{
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
                direction={'row'}
              >
                <TextField
                  fullWidth
                  disabled
                  value={props.inputs2.post ? props.inputs2.post : ''}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                    },
                  }}
                />
                <Button
                  sx={{
                    width: '40%',
                    height: '80%',
                    ml: 1,
                    borderRadius: 12,
                    backgroundColor: '#E9F0F1',
                    '&:hover': {
                      backgroundColor: '#E9F0F1', // hover 시 배경색
                    },
                    color: '#00602E',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }}
                  name={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter(
                          (f) => f.LAN_ID === 'SearchAddress'
                        )[0].LAN_NM // 주소 검색
                      : ''
                  }
                  onClick={() => setKakaoPost(true)}
                />
              </Stack>
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Address')[0]
                      .LAN_NM // 주소(Address)
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={props.inputs2.address1 ? props.inputs2.address1 : ''}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'AddressDtl')[0]
                      .LAN_NM // 나머지주소
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.address2 ? props.inputs2.address2 : ''}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    address2: e.target.value,
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Experience')[0]
                      .LAN_NM // 경력유무
                  : ''}
              </Typography>
              <Radio
                nameSx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: '24px',
                  }, // 체크박스 아이콘 크기 설정
                  '& .MuiFormControlLabel-label': {
                    fontSize: '16px', // 레이블 글자 크기 설정
                  },
                }}
                row
                value={props.inputs2.careerYn ? props.inputs2.careerYn : 'N'}
                onChange={(e) => {
                  if (e === 'Y') {
                    props.setInputs2({
                      ...props.inputs2,
                      careerYn: e,
                    });
                  } else {
                    props.setInputs2({
                      ...props.inputs2,
                      careerYn: e,
                      careerPeriod: null,
                    });
                  }
                }}
                items={[
                  { value: 'Y', name: '예' },
                  { value: 'N', name: '아니오' },
                ]}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'CareerPeriod')[0]
                      .LAN_NM // 경력기간
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.careerPeriodList}
                value={
                  props.inputs2.careerYn === 'N'
                    ? ''
                    : props.inputs2.careerPeriod
                }
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    careerPeriod: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                  fontSize: '16px',
                }}
                size="small"
                disabled={props.inputs2.careerYn === 'N' ? true : false}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'space-between',
              }}
              direction="row"
            >
              <Typography
                variant="body2"
                gutterBottom
                sx={{
                  color: 'gray',
                  px: 1,
                  my: 0,
                  fontSize: '14px',
                }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'HealthCard')[0]
                      .LAN_NM // 보건카드
                  : ''}
              </Typography>
              <Button
                sx={{
                  borderRadius: 12,
                  backgroundColor: '#E9F0F1',
                  '&:hover': {
                    backgroundColor: '#E9F0F1', // hover 시 배경색
                  },
                  color: '#00602E',
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}
                name={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.LAN_ID === 'Look')[0].LAN_NM // 보기
                    : ''
                }
                onClick={() => {
                  props.SearchLogic2(props.inputs2.healthImage, 'health');
                  props.setImageDialog(true);
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, fontSize: '14px' }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Visa')[0].LAN_NM // Visa
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs2.visa ? props.inputs2.visa : ''}
                onChange={(e) => {
                  props.setInputs2({
                    ...props.inputs2,
                    visa: e.target.value,
                  });
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '16px',
                  },
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'space-between',
              }}
              direction="row"
            >
              <Typography
                variant="body2"
                gutterBottom
                sx={{
                  color: 'gray',
                  px: 1,
                  my: 0,
                  fontSize: '14px',
                }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'SignatureName')[0]
                      .LAN_NM // 서명
                  : ''}
              </Typography>
              <Button
                sx={{
                  borderRadius: 12,
                  backgroundColor: '#E9F0F1',
                  '&:hover': {
                    backgroundColor: '#E9F0F1', // hover 시 배경색
                  },
                  color: '#00602E',
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}
                name={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.LAN_ID === 'Look')[0].LAN_NM // 보기
                    : ''
                }
                onClick={() => {
                  props.SearchLogic2(props.inputs2.sign, 'sign');
                  props.setSignDialog(true);
                }}
              />
            </Stack>
          </ListItem>
          {(props.userInfo.authCd === 'HEAD_MANAGER' ||
            props.userInfo.authCd === 'BUSINESS_OWNER' ||
            props.userInfo.authCd === 'ADMIN') && (
            <ListItem sx={{ pb: 3 }}>
              <Stack
                sx={{
                  width: '100%',
                  justifyContent: 'space-between',
                }}
                direction="row"
              >
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{
                    color: 'gray',
                    px: 1,
                    my: 0,
                    fontSize: '14px',
                  }}
                >
                  직인
                </Typography>
                <Button
                  sx={{
                    borderRadius: 12,
                    backgroundColor: '#E9F0F1',
                    '&:hover': {
                      backgroundColor: '#E9F0F1', // hover 시 배경색
                    },
                    color: '#00602E',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }}
                  name={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter((f) => f.LAN_ID === 'Look')[0]
                          .LAN_NM // 보기
                      : ''
                  }
                  onClick={() => {
                    props.SearchLogic2(props.inputs2.journeyman, 'journeyman');
                    props.setModalToggle5(true);
                  }}
                />
              </Stack>
            </ListItem>
          )}
          <ListItem sx={{ pt: 2 }}>
            <Button
              sx={{
                color: 'rgba(0,0,0,0.5)',
                fontSize: '16px',
              }}
              variant="text"
              name={'회원탈퇴 >'}
              onClick={() => {
                props.setModalToggle4(true);
              }}
            />
          </ListItem>
          <ListItem sx={{ pt: 2 }}>
            <Button
              sx={{
                backgroundColor: '#FFDE5A',
                color: '#000',
                fontSize: '18px',
                borderRadius: '16px',
              }}
              fullWidth
              name={
                props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.LAN_ID === 'Save')[0].LAN_NM // 저장
                  : ''
              }
              onClick={() => {
                props.SaveLogic1();
              }}
            />
          </ListItem>
        </List>
        <KakaoPost
          open={kakaoPost}
          onClose={() => setKakaoPost(false)}
          title={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'SearchAddress')[0]
                  .LAN_NM // 주소 검색
              : ''
          }
          ReceivePost={(_data) => GetPostData(_data)}
        />
      </Stack>
    </>
  );

  const view = () => {
    switch (props.viewState) {
      case 0:
        return myPageDefault();
      case 1:
        return profile();
    }
  };
  //#endregion

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ width: '100%', height: '56px' }} />
      {view()}
      {/* 비밀번호 확인 */}
      {props.mobileModalToggle && (
        <Dialog
          title={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'PasswordConfirm')[0]
                  .LAN_NM // 비밀번호 확인
              : ''
          }
          titleSx={{ fontWeight: 'bold', fontSize: '20px' }}
          open={props.mobileModalToggle}
          onClose={() => {
            props.setInputs({
              ...props.inputs,
              currentPassword: '',
              password: '',
              passwordConfirm: '',
            });
            props.setMobileModalToggle(false);
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          PaperProps={{ sx: { borderRadius: 4 } }}
          fullWidth
          useCloseButton={true}
          useSaveButton={true}
          closeButtonName={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'Close')[0].LAN_NM // 닫기
              : ''
          }
          saveButtonName={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'Confirm')[0].LAN_NM // 확인
              : ''
          }
          onSave={() => props.SearchLogic1()}
          maxWidth="sm"
          content={
            <Box>
              <Stack
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                }}
                spacing={2}
              >
                <Typography variant="h5" sx={{ fontSize: '24px' }}>
                  {props.lanInfo.length > 0
                    ? props.lanInfo.filter(
                        (f) => f.LAN_ID === 'PleaseEnterYourPassword'
                      )[0].LAN_NM // 비밀번호를 입력하세요.
                    : ''}
                </Typography>
                <TextField
                  fullWidth
                  type="password"
                  label=""
                  value={props.certificationInputs.passwoard}
                  onChange={(e) => {
                    props.setCertificationInputs({
                      ...props.certificationInputs,
                      passwoard: e.target.value,
                    });
                  }}
                  onKeyDown={(e) => e.key === 'Enter' && props.SearchLogic1()}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                    },
                  }}
                  autoFocus
                />
              </Stack>
            </Box>
          }
        />
      )}
      {/* 비밀번호 변경 */}
      {props.mobileModalToggle2 && (
        <Dialog
          title={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'ChangePassword')[0]
                  .LAN_NM // 비밀번호 변경
              : ''
          }
          titleSx={{ fontWeight: 'bold', fontSize: '20px' }}
          open={props.mobileModalToggle2}
          onClose={() => {
            props.setInputs({
              ...props.inputs,
              currentPassword: '',
              password: '',
              passwordConfirm: '',
            });
            props.setMobileModalToggle2(false);
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          PaperProps={{ sx: { borderRadius: 4 } }}
          fullWidth
          useCloseButton={true}
          useSaveButton={true}
          closeButtonName={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'Close')[0].LAN_NM // 닫기
              : ''
          }
          saveButtonName={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.LAN_ID === 'Confirm')[0].LAN_NM // 확인
              : ''
          }
          onSave={() => {
            props.SaveLogic2();
            props.setInputs({
              ...props.inputs,
              currentPassword: '',
              password: '',
              passwordConfirm: '',
            });
            props.setMobileModalToggle2(false);
          }}
          maxWidth="sm"
          content={
            <Box sx={{ p: 1 }}>
              <Stack spacing={2}>
                <TextField
                  label={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter(
                          (f) => f.LAN_ID === 'CurrentPassword'
                        )[0].LAN_NM // 현재 비밀번호
                      : ''
                  }
                  value={
                    props.inputs.currentPassword
                      ? props.inputs.currentPassword
                      : ''
                  }
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      currentPassword: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '16px', // 입력 텍스트 크기를 16px로 설정
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '16px', // 라벨 크기를 16px로 설정
                    },
                  }}
                  type="password"
                />
                <TextField
                  fullWidth
                  label={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter((f) => f.LAN_ID === 'Password')[0]
                          .LAN_NM // 비밀번호
                      : ''
                  }
                  value={props.inputs.password ? props.inputs.password : ''}
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      password: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '16px',
                    },
                  }}
                  type="password"
                />
                <TextField
                  fullWidth
                  label={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter(
                          (f) => f.LAN_ID === 'PasswordConfirm'
                        )[0].LAN_NM // 비밀번호 확인
                      : ''
                  }
                  value={
                    props.inputs.passwordConfirm
                      ? props.inputs.passwordConfirm
                      : ''
                  }
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      passwordConfirm: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => props.checkCapsLock(e)}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '16px',
                    },
                  }}
                  type="password"
                />
                {props.capsLockFlag && (
                  <Typography variant="caption" color="red">
                    {`Caps Lock이 켜져 있습니다`}
                  </Typography>
                )}
                <Typography variant="caption">
                  {`(8자리 이상, 대문자, 숫자, 특수문자(!@#$%^&*)가 포함되어야합니다.)`}
                </Typography>
              </Stack>
            </Box>
          }
        />
      )}
      {/* 보건카드 팝업창 */}
      {props.imageDialog && (
        <Dialog
          title={
            props.lanInfo.length <= 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ImageSetup'
                ).LAN_NM
          } //사진 설정
          open={props.imageDialog}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              healthFiles: '',
              healthImage: '',
            });
            props.setImageDialog(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '50vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length <= 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //저장
          closeButtonName={
            props.lanInfo.length <= 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.SaveLogic3();
            if (props.imageFile.healthImage) {
              props.setImageFile({
                ...props.imageFile,
                healthFiles: '',
                healthImage: '',
              });
              props.setImageDialog(false);
            }
          }}
          maxWidth="sm"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <FileForm
                datas={[
                  {
                    type: Commons.TypeFile().toLowerCase(),
                    name:
                      props.lanInfo.length <= 0
                        ? ''
                        : props.lanInfo.find(
                            (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'File'
                          ).LAN_NM, //파일
                    onChange: (event) => {
                      const fileList = event.target.files;
                      if (Object.keys(fileList).length === 0) return;

                      const file = fileList[0]; // single file upload

                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = (e) => {
                        fetch(e.target.result)
                          .then((res) => res.blob())
                          .then((blob) => {
                            const image = new File(
                              [blob],
                              `${new Date()
                                .toISOString()
                                .replace(/T/, '')
                                .replace(/\..+/, '')
                                .replace(/-/g, '')
                                .replace(/:/g, '')}.png`,
                              {
                                type: 'image/png',
                              }
                            );

                            props.setInputs2({
                              ...props.inputs2,
                              profile_img: reader.result,
                            });

                            props.setImageFile({
                              ...props.imageFile,
                              healthFiles: reader.result,
                              healthImage: image,
                              healthFileName: file.name,
                            });
                          });
                      };
                      reader.onerror = (error) => {
                        console.log(error);
                        // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                      };
                    },
                    buttonName:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) =>
                              f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                          ).LAN_NM, //파일 업로드
                  },
                ]}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '85%',
                  pt: 1.5,
                }}
              >
                {props.imageFile.healthFiles ? (
                  <img
                    id={'fileId'}
                    src={props.imageFile.healthFiles || ''}
                    style={{
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <Typography variant="h6">
                    등록된 보건카드가 없습니다.
                  </Typography>
                )}
              </Box>
            </div>
          }
        />
      )}
      {/* 서명 보기 팝업 창 */}
      {props.signDialog && (
        <Dialog
          title={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'SignatureName'
                ).LAN_NM
          } //서명
          titleSx={{ fontSize: '24px' }}
          open={props.signDialog}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              signFiles: '',
              signImage: '',
            });
            props.setSignDialog(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '50vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={true}
          onSave={{}}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <MuiButton
                sx={{
                  minWidth: '50%',
                  borderRadius: '8px',
                  backgroundColor: '#FFD839',
                  color: '#000000',
                  fontSize: 20,
                  // '&:hover': {
                  //     backgroundColor:
                  //         , // 원하는 hover 배경색으로 설정
                  // },
                }}
                onClick={(e) => {
                  props.setSignCreateDialog(true);
                }}
              >
                <img
                  src={vector}
                  alt="icon"
                  style={{
                    marginRight: 8,
                  }}
                />
                {'서명하기'}
              </MuiButton>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '85%',
                  pt: 1.5,
                }}
              >
                <img
                  id={'fileId'}
                  src={props.imageFile.signFiles || ''}
                  style={{
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </div>
          }
        />
      )}
      {/* 서명 등록 팝업창 */}
      {props.signCreateDialog && (
        <Dialog
          open={props.signCreateDialog}
          titleSx={{ fontSize: 25 }}
          onClose={(e) => props.setSignCreateDialog(false)}
          contentSx={{
            display: 'flex',
            height: '50vh',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={'서명 등록'}
          content={
            <Canvas
              signatureCanvas={signatureCanvas}
              userId={props.inputs2.name}
            />
          }
          fullWidth
          saveButtonName={'저장'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          maxWidth="md"
          onSave={(e) => {
            if (signatureCanvas.current) {
              const signatureDataUrl = signatureCanvas.current.toDataURL();
              props.setWorkSignature(signatureDataUrl);
              // handleOcr();
              const dataURL = signatureCanvas.current.toDataURL('image/png');

              // base64 데이터를 디코딩하여 Blob 생성
              const decodedData = atob(dataURL.split(',')[1]); // base64 부분만 분리하고 디코딩
              const byteNumbers = new Array(decodedData.length);

              // Uint8Array로 변환
              for (let i = 0; i < decodedData.length; i++) {
                byteNumbers[i] = decodedData.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);

              const blob = new Blob([byteArray], {
                type: 'image/png',
              });
              const image = new File(
                [blob],
                `${new Date()
                  .toISOString()
                  .replace(/T/, '')
                  .replace(/\..+/, '')
                  .replace(/-/g, '')
                  .replace(/:/g, '')}.png`,
                {
                  type: 'image/png',
                }
              );
              if (!signatureCanvas.current._sigPad._isEmpty) {
                props.SaveLogic4(image);
                props.setSignCreateDialog(false);
              } else {
                props.setSnackbar({
                  ...props.snackbar,
                  open: true,
                  message: '서명을 진행하세요.',
                  type: Commons.TypeError().toLowerCase(),
                });
              }
            }
          }}
        />
      )}
      {/* 회원 탈퇴 팝업 창 */}
      {props.modalToggle4 && (
        <Dialog
          open={props.modalToggle4}
          titleSx={{ fontSize: '3rem' }}
          onClose={(e) => props.setModalToggle4(false)}
          contentSx={{
            display: 'flex',
          }}
          fullScreen
          title={'탈퇴 안내'}
          btnSx={{ width: '5vw', height: '4vh', fontSize: '2rem' }}
          content={
            <Box sx={{ p: 1 }}>
              <Typography sx={{ fontSize: '2rem' }}>
                회원탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.
              </Typography>
              <Typography
                sx={{
                  fontSize: '2rem',
                  mt: 2,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                사용하고 계신 아이디({props.userInfo.userid})는 탈퇴할 경우
                재사용 및 복구가 불가능합니다.
              </Typography>
              <Box sx={{ ml: 2, mt: 2 }}>
                <Typography sx={{ fontSize: '2rem', color: 'red' }}>
                  탈퇴한 아이디는 본인과 타인 모두 재사용 및 복구가 불가
                </Typography>
                <Typography sx={{ fontSize: '2rem' }}>
                  하오니 신중하게 선택하시기 바랍니다.
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: '2rem',
                  mt: 5,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                탈퇴 후 회원정보 및 개인형 서비스 이용기록은 모두 삭제됩니다.
              </Typography>
              <Typography
                sx={{
                  fontSize: '2rem',
                  mt: 5,
                  mb: 5,
                  color: 'red',
                }}
              >
                탈퇴 후에는 아이디 {props.userInfo.userid} 로 다시 가입할 수
                없으며 아이디와 데이터는 복구할 수 없습니다.
                <br />
                게시판형 서비스에 남아 있는 게시글은 탈퇴 후 삭제할 수 없습니다.
              </Typography>
              <Checkbox
                name={'안내 사항을 모두 확인하였으며, 이에 동의합니다.'}
                checked={props.idDelete}
                onChange={(e) => props.setIdDelete(e)}
                nameSx={{ fontSize: '16px' }}
              />
            </Box>
          }
          fullWidth
          saveButtonName={'확인'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          maxWidth="md"
          onSave={(e) => {
            if (props.idDelete) {
              props.DeleteLogic1();
            } else {
              props.setSnackbar({
                ...props.snackbar,
                open: true,
                message: '탈퇴 안내를 확인하고 동의하세요.',
                type: Commons.TypeError().toLowerCase(),
              });
            }
          }}
        />
      )}
      {/* 직인 팝업 창 */}
      {props.modalToggle5 && (
        <Dialog
          title={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ImageSetup'
                ).LAN_NM
          } //사진 설정
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle5}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              journeyFiles: '',
              journeyImage: '',
            });
            props.setModalToggle5(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '40vh',
          }}
          fullWidth
          saveButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Save'
                ).LAN_NM
          } //선택
          closeButtonName={
            props.lanInfo.length == 0
              ? ''
              : props.lanInfo.find(
                  (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.SaveLogic5();
            if (props.imageFile.journeyImage) {
              props.setImageFile({
                ...props.imageFile,
                journeyFiles: '',
                journeyImage: '',
              });
              props.setModalToggle5(false);
            }
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <Button
                sx={{
                  // backgroundColor: "#FFDE5A",
                  // color: "#000",
                  fontSize: '14px',
                  height: '38px',
                  borderRadius: '4px',
                  mb: 1,
                }}
                size="medium"
                name={'직인 예시 보기'}
                onClick={() => {
                  props.setModalToggle6(true);
                }}
              />
              <FileForm
                datas={[
                  {
                    type: Commons.TypeFile().toLowerCase(),
                    sx: { fontSize: 14 },
                    name:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) => f.LAN_TYPE == 'CALL' && f.LAN_ID === 'File'
                          ).LAN_NM, //파일
                    // value: props.imageFile.journeyFiles || "",
                    onChange: (event) => {
                      const fileList = event.target.files;
                      if (Object.keys(fileList).length === 0) return;

                      const file = fileList[0]; // single file upload

                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = (e) => {
                        fetch(e.target.result)
                          .then((res) => res.blob())
                          .then((blob) => {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');

                            const img = new Image();
                            img.crossOrigin = 'Anonymous'; // CORS 문제 방지
                            img.src = reader.result; // 원본 이미지

                            img.onload = function () {
                              canvas.width = img.width;
                              canvas.height = img.height;
                              ctx.drawImage(img, 0, 0);

                              const imageData = ctx.getImageData(
                                0,
                                0,
                                canvas.width,
                                canvas.height
                              );
                              const data = imageData.data;

                              // 특정 색(흰색) 제거: RGB(255,255,255)에 가까운 색을 투명화
                              for (let i = 0; i < data.length; i += 4) {
                                const r = data[i]; // Red
                                const g = data[i + 1]; // Green
                                const b = data[i + 2]; // Blue
                                const a = data[i + 3]; // Alpha (투명도)

                                // 흰색(또는 거의 흰색)이라면 투명하게 변경
                                if (r > 200 && g > 200 && b > 200) {
                                  data[i + 3] = 0; // 완전 투명하게 설정
                                }
                              }

                              ctx.putImageData(imageData, 0, 0);

                              // Data URL 형태로 PNG 이미지로 변환
                              const transparentImage =
                                canvas.toDataURL('image/png'); // 투명한 배경의 PNG 출력

                              // Data URL을 Blob으로 변환
                              fetch(transparentImage)
                                .then((res) => res.blob()) // Blob으로 변환
                                .then((blob) => {
                                  // Blob을 File 객체로 변환하여 저장
                                  const image = new File(
                                    [blob],
                                    `${new Date()
                                      .toISOString()
                                      .replace(/T/, '')
                                      .replace(/\..+/, '')
                                      .replace(/-/g, '')
                                      .replace(/:/g, '')}.png`,
                                    {
                                      type: 'image/png',
                                    }
                                  );

                                  props.setImageFile({
                                    ...props.imageFile,
                                    journeyFiles: transparentImage,
                                    journeyImage: image, // image 객체는 File 형태
                                    journeyFileName: file.name,
                                  });
                                })
                                .catch((err) => {
                                  console.error(
                                    'Error while converting image to Blob:',
                                    err
                                  );
                                });
                            };
                          });
                      };
                      reader.onerror = (error) => {
                        console.log(error);
                        // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                      };
                    },
                    buttonName:
                      props.lanInfo.length == 0
                        ? ''
                        : props.lanInfo.find(
                            (f) =>
                              f.LAN_TYPE == 'CALL' && f.LAN_ID === 'FileUpload'
                          ).LAN_NM, //파일 업로드
                  },
                ]}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                {props.imageFile.journeyFiles ? (
                  <img
                    id={'fileId'}
                    src={props.imageFile.journeyFiles || ''}
                    style={{
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <Typography variant="h4">등록된 직인이 없습니다.</Typography>
                )}
              </Box>
            </div>
          }
        />
      )}
      {/* 직인 예시 팝업 창 */}
      {props.modalToggle6 && (
        <Dialog
          title={'직인 예시'}
          titleSx={{ fontSize: '24px' }}
          open={props.modalToggle5}
          onClose={(e) => {
            props.setImageFile({
              ...props.imageFile,
              journeyFiles: '',
              journeyImage: '',
            });
            props.setModalToggle5(false);
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '20vh',
          }}
          fullWidth
          useSaveButton={true}
          useCloseButton={false}
          saveButtonName={'확인'}
          closeButtonName={''}
          useSaveAfterClose={false}
          onSave={() => {
            props.setModalToggle6(false);
          }}
          maxWidth="sm"
          btnSx={{ width: '120px', height: '60px' }}
          content={
            <Box
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                alignContent: 'center',
              }}
            >
              <Typography sx={{ fontSize: '14px', mb: 2 }}>
                직인의 배경은 흰색 또는 투명해야 합니다.
              </Typography>
              <Stack
                direction="row"
                spacing={8}
                sx={{
                  display: 'flext',
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
              >
                <img
                  src={safeonJourneyman1}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
                <img
                  src={safeonJourneyman2}
                  style={{
                    maxWidth: '25%',
                    objectFit: 'contain',
                  }}
                />
              </Stack>
            </Box>
          }
        />
      )}
    </ThemeProvider>
  );
}

export default MyPage_Mobile;
